import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useRefreshData = (selector, action, refreshInterval = 300000) => {
  const dispatch = useDispatch();
  const { lastFetched, loading } = useSelector(selector);

  useEffect(() => {
    const shouldRefresh = !lastFetched || Date.now() - lastFetched > refreshInterval;
    
    if (shouldRefresh && !loading) {
      dispatch(action());
    }
  }, [dispatch, lastFetched, loading, action, refreshInterval]);
};
